import { render, staticRenderFns } from "./RichEdit.vue?vue&type=template&id=320b1323&scoped=true"
import script from "./RichEdit.vue?vue&type=script&lang=js"
export * from "./RichEdit.vue?vue&type=script&lang=js"
import style0 from "./RichEdit.vue?vue&type=style&index=0&id=320b1323&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "320b1323",
  null
  
)

export default component.exports